// extracted by mini-css-extract-plugin
module.exports = {"bdnPage":"blogDetail_bdnPage__dXrzR","bdn-marquee":"blogDetail_bdn-marquee__LSiIj"};